import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c701d50c"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=c701d50c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports